<template>
<div class="chapter">
<div class="inner_page">
<div class="blockquote">
<p class="center"><em class="italic">For my Aunt Jean and Uncle Fred Bradshaw</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm1.vue?4d3bc27f